import { SafiVatEnum } from 'api';
import { CountryAutocompleteField, IncotermSelectField, SelectField, TextField, useFormContext } from 'form';
import { ChangeEvent, useContext } from 'react';
import { SectionContainer } from 'ui';

import { PurchaseOrderFormContext } from '../../contexts/PurchaseOrderFormContext';
import { CreateFormValues } from '../../pages/PurchaseOrderCreate/PurchaseOrderCreate';
import { selectableIncoterms } from '../../schemas/basePurchaseOrderSchema';

const VAT_OPTIONS = Object.values(SafiVatEnum).map((value) => ({
  label: value,
  value: value,
}));

export const SellerDealDetailsSection = () => {
  const { setValue, getValues } = useFormContext<CreateFormValues>();
  const { variant } = useContext(PurchaseOrderFormContext);

  const handleTonnesPerLoadChange = (e: ChangeEvent<HTMLInputElement>) => {
    const numberOfLoads = getValues('number_of_loads');
    setValue('tonnes', String(Number(e.target.value) * Number(numberOfLoads)));
  };

  const handleNumberOfLoadsChange = (e: ChangeEvent<HTMLInputElement>) => {
    const tonnesPerLoad = getValues('tonnes_per_load');
    setValue('tonnes', String(Number(e.target.value) * Number(tonnesPerLoad)));
  };

  return (
    <SectionContainer title="Commercial Details">
      <IncotermSelectField
        selectableIncoterms={selectableIncoterms}
        infoTooltip="International commercial term that defines responsibilities and costs between Safi and the seller. "
      />
      <TextField
        name="tonnes_per_load"
        label="Tonnes per load"
        type="number"
        required
        infoTooltip="Average weight or payload of one container or truck."
        onChange={handleTonnesPerLoadChange}
      />
      <TextField
        label="Number of loads"
        name="number_of_loads"
        type="number"
        required
        infoTooltip="Number of containers or trucks that will be collected."
        onChange={handleNumberOfLoadsChange}
      />

      {variant === 'create' ? (
        <CountryAutocompleteField label="Where is the material going to?" name="final_destination_country" required />
      ) : null}
      {variant === 'update' ? <SelectField name="safi_vat" label="Safi VAT" options={VAT_OPTIONS} required /> : null}
      <TextField
        type="number"
        name="tonnes"
        label="Number of tonnes"
        disabled
        infoTooltip="Calculated value. Tonnes = Tonnes per load x Number of loads."
      />
    </SectionContainer>
  );
};
